// Added by Jonghyung Lee on 2021-12-13
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { FC } from 'react'
import { makeStyles, createStyles } from '@material-ui/core'
import clsx from 'clsx'

import Intl from '@/helper/Intl'

interface WPSMonitoringProps {
  classes?: any
  waitingCount: number
  runningCount: number
  onBoxClick: () => void
}

/** 특정 User가 시작한 Running 상태의 WPS들을 모아서 보여줌 */
const WPSMonitoring: FC<WPSMonitoringProps> = ({
  classes: webComponentClassses,
  waitingCount,
  runningCount,
  onBoxClick,
  ...props
}) => {
  const classes = webComponentClassses
    ? webComponentClassses['wpsmonitoringbox']
    : makeStyles(() => createStyles({ ...customStyles }))()

  const wpsText = Intl.getIntlText({ id: 'htmljs_react.worklist.wpsmonitoringbox.label_wps' })
  const waitingText = Intl.getIntlText({ id: 'htmljs_react.worklist.wpsmonitoringbox.label_waiting' })
  const runningText = Intl.getIntlText({ id: 'htmljs_react.worklist.wpsmonitoringbox.label_running' })

  return (
    <div className={classes.wrapper} onClick={onBoxClick}>
      <div>{wpsText}</div>
      <div className={classes.secondRow}>
        <span className={clsx({ active: runningCount > 0 })}>
          {runningText} <strong>{runningCount}</strong>
        </span>
        <span>{'/'}</span>
        <span>
          {waitingText} <strong>{waitingCount}</strong>
        </span>
      </div>
    </div>
  )
}

export const customStyles: Record<string, any> = {
  wrapper: {
    display: 'flex',
    backgroundColor: '#1a1a1a',
    fontSize: '11px',
    width: '160px',
    height: '46px',
    flexDirection: 'column',
    padding: '5px 8px',
    boxSizing: 'border-box',
    justifyContent: 'space-between',
    color: '#fff',
    cursor: 'pointer',
  },
  secondRow: {
    justifyContent: 'center',
    paddingBottom: '4px',
    display: 'flex',
    '& > span': {
      '&.active': {
        color: '#6D973F',
      },
      '&:nth-child(2)': {
        margin: '0 4px',
      },
      color: '#A6A6A6',
      '& > strong': {
        fontWeight: 900,
        color: '#fff',
      },
    },
  },
}

export default WPSMonitoring
